import { guaranteedGetUserMediaException, NoTrackError, setContentHint, } from "./utils";
import { Logger } from "../../Logger";
import { setAudioContextUnlocked } from "gather-client-common/dist/src/public/audioContext";
import { metricsManager as globalsMetricsManager } from "../../Globals";
import { Err, Ok } from "gather-common-including-video/dist/src/public/result";
export const getAudioConstraints = ({ device, echoCancellation, autoGainControl, noiseSuppression, }) => {
    const constraints = {
        echoCancellation: echoCancellation,
        autoGainControl: autoGainControl,
        noiseSuppression: noiseSuppression,
        sampleRate: {
            ideal: 48000,
            min: 8000,
            max: 96000,
        },
    };
    if (device?.deviceId) {
        constraints.deviceId = { exact: device.deviceId };
    }
    return constraints;
};
const getAudioStreamOrThrow = async (settings) => {
    const constraints = { audio: getAudioConstraints(settings) };
    Logger.info("[LMM] calling getUserMedia with ", JSON.stringify(constraints));
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    setContentHint(stream.getAudioTracks()[0], settings.echoCancellation && settings.autoGainControl ? "speech" : "music");
    setAudioContextUnlocked();
    return stream;
};
export const getAudioStreamWithErrors = async (settings) => {
    try {
        const stream = await getAudioStreamOrThrow(settings);
        Logger.info("[LMM] Fetching audio track from stream");
        const audio = stream.getAudioTracks()[0];
        if (!audio)
            return { audio: Err(new NoTrackError()) };
        globalsMetricsManager.setAttribute("selected-audio-device-label", audio.label);
        return { audio: Ok(audio) };
    }
    catch (e) {
        const error = guaranteedGetUserMediaException(e);
        return { audio: Err(error) };
    }
};
//# sourceMappingURL=Audio.js.map